const usersSearchActions = {
  USERS_SEARCH_INIT_STATE_SET: 'USERS_SEARCH_INIT_STATE_SET',
  USERS_SEARCH_PROP_UPDATE: 'USERS_SEARCH_PROP_UPDATE',
  USERS_SEARCH_PROP_DELETE: 'USERS_SEARCH_PROP_DELETE'
};
export default usersSearchActions;
